import { useSelector } from 'react-redux';
import { selectRegionId } from '../selectors/offer';
import { EMultiPostingAvailablePlatforms, IMultiPostingPlatformsByRegion } from '../types/reducers/multiPosting';
import { useAppContext } from '../../AppModulesWrapper';
import { selectMultiPostingAvailablePlatforms } from '../selectors/publishTerms';

export const useMultiPostingPlatforms = (): string[] => {
  const { config } = useAppContext();
  const availablePlatforms = useSelector(selectMultiPostingAvailablePlatforms);
  const regionId = useSelector(selectRegionId);
  const platformsByRegion = config.get<IMultiPostingPlatformsByRegion>('addformConfig.multiPosting.platforms') || {};
  const platforms = platformsByRegion[String(regionId)];

  if (!platforms) {
    return [];
  }

  if (availablePlatforms === EMultiPostingAvailablePlatforms.Free) {
    return platforms.free;
  } else if (availablePlatforms === EMultiPostingAvailablePlatforms.All) {
    return platforms.paid.concat(platforms.free);
  }

  return [];
};
